// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* displayTicker.css
   Final update: landscape ticker no longer overlaps media.
   - Reserves right-side space when portrait ticker present (as before).
   - Reserves bottom space when landscape ticker present so media area is shrunk (no JS changes).
   - Uses CSS variables with :has() when available; includes comments for fallback.
*/

/* ===== CONFIG / FALLBACK ===== */
:root {
  --ticker-reserve: 0px;         /* horizontal reserve for portrait (default) */
  --ticker-default-width: 60px;  /* default portrait width */
  --ticker-bottom-reserve: 0px;  /* bottom reserve for landscape (default) */
  --ticker-default-height: 60px; /* default landscape height */
}

/* If browser supports :has(), set reserves dynamically when tickers exist */
:root:has(.display-ticker.portrait) {
  --ticker-reserve: var(--ticker-default-width);
}
:root:has(.display-ticker.landscape) {
  --ticker-bottom-reserve: var(--ticker-default-height);
}

/* OPTIONAL fallbacks for older WebViews (uncomment if :has() unsupported)
   Uncomment to always reserve space:
   :root { --ticker-reserve: 60px; --ticker-bottom-reserve: 60px; }
*/

/* ===== DISPLAY TICKER BASE ===== */
.display-ticker {
  position: absolute;   /* floats above the content */
  box-sizing: border-box;
  overflow: hidden;
  z-index: 25;          /* above media layer */
  color: inherit;
  display: flex;
  align-items: center;
}

/* text style */
.display-ticker-text {
  font-weight: 600;
  letter-spacing: 1px;
  transform: skewX(-12deg);
  line-height: 1;
  padding-top: 2px;
  text-shadow: 0 0 6px currentColor;
  display: inline-block;
}

/* track */
.display-ticker-track {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  will-change: transform;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* ticker item */
.ticker-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== LANDSCAPE (BOTTOM) ===== */
.display-ticker.landscape {
  left: 0;
  bottom: 0;
  width: 100%;
  /* use variable so CSS can update layout when ticker exists */
  height: var(--ticker-bottom-reserve);
  min-height: 0;
  padding: 0 12px;
  align-items: center;
}

/* spacing between messages in landscape */
.display-ticker.landscape .ticker-item {
  margin-right: 300px;
}

/* default horizontal animation (left) */
.display-ticker.landscape .display-ticker-track {
  animation-name: ticker-left;
}

/* landscape direction override (rightwards) */
.display-ticker.landscape.right .display-ticker-track {
  animation-name: ticker-right;
}

/* ===== PORTRAIT (RIGHT SIDE) ===== */
.display-ticker.portrait {
  top: 0;
  right: 0;
  height: 100%;
  width: var(--ticker-reserve); /* controlled by :has() or fallback */
  min-width: 48px;
  display: block;
  pointer-events: auto;
}

/* portrait track uses vertical column + transform-based animation (viewport-based) */
.display-ticker.portrait .display-ticker-track {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-120vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 240px; /* spacing between items */
  animation-name: ticker-portrait;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* rotate text so it reads horizontally when rotated on the right side */
.display-ticker.portrait .display-ticker-text {
  white-space: nowrap;
  transform: rotate(-90deg) skewX(-12deg);
  transform-origin: center;
}

/* if portrait direction should be reversed, target .portrait.right on the component */
.display-ticker.portrait.right .display-ticker-track {
  animation-name: ticker-portrait-reverse;
}

/* ===== SPEEDS (horizontal defaults) ===== */
.display-ticker.slow .display-ticker-track { animation-duration: 30s; }
.display-ticker.medium .display-ticker-track { animation-duration: 15s; }
.display-ticker.fast .display-ticker-track { animation-duration: 8s; }

/* ===== PORTRAIT SPEED ADJUSTMENTS (to match perceived horizontal speed) ===== */
.display-ticker.portrait.slow .display-ticker-track { animation-duration: 20s; }
.display-ticker.portrait.medium .display-ticker-track { animation-duration: 10s; }
.display-ticker.portrait.fast .display-ticker-track { animation-duration: 6s; }

/* ===== KEYFRAMES ===== */
/* horizontal left-to-right (landscape) */
@keyframes ticker-left {
  from { transform: translateX(100vw); }
  to   { transform: translateX(-100%); }
}

/* horizontal rightwards (landscape) */
@keyframes ticker-right {
  from { transform: translateX(-100%); }
  to   { transform: translateX(100vw); }
}

/* portrait: travel using viewport height to ensure full-screen travel */
@keyframes ticker-portrait {
  from { transform: translateX(-50%) translateY(-120vh); }
  to   { transform: translateX(-50%) translateY(120vh); }
}

@keyframes ticker-portrait-reverse {
  from { transform: translateX(-50%) translateY(120vh); }
  to   { transform: translateX(-50%) translateY(-120vh); }
}

/* ===== MEDIA LAYER (ANDROID TV SAFE) ===== */
.media-layer {
  position: relative;
  width: 100%;
  /* reduce media height when landscape ticker exists (reserve bottom) */
  background: black;
  overflow: hidden;
  z-index: 5; /* below ticker overlay */
  box-sizing: border-box;
}

/* Video / Image are absolutely positioned and respect the right gutter
   reserved for the portrait ticker via --ticker-reserve. Use contain to avoid cropping. */
.display-video,
.display-image {
  position: absolute;
  top: 0;
  left: 0;
  right: var(--ticker-reserve); 
   /* reserve space on the right for portrait ticker */
  bottom: 0;
  width: auto;
  height: 100%;
  object-fit: fill; /* ensure whole image is visible */
  background: black;
  display: none; /* JS toggles to 'block' when showing media */
  z-index: 6;
  pointer-events: none; /* signage-safe */
  -webkit-user-select: none;
          user-select: none;
}

/* ensure native video controls don't appear on some platforms */
.display-video::-webkit-media-controls { display: none !important; }

/* video appearance safety */
.display-video {
  outline: none;
  -webkit-user-select: none;
  user-select: none;
  backface-visibility: hidden;
}

/* optional helper: allow a wrapper that fills the remaining width (if used) */
.video-wrap {
  flex: 1 1;
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: black;
}

.video-wrap video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
  max-width: none;
  max-height: none;
}

/* ===== NOTES =====
 - This CSS uses :has() when available to detect presence of .display-ticker.landscape
   and .display-ticker.portrait. If your WebView doesn't support :has(), enable the
   fallback by uncommenting the fallback section above to always reserve the expected
   ticker size.
 - The DisplayPage.jsx already sets inline height for media-layer when it knows the
   ticker height; this CSS provides a safe fallback so landscape won't overlap even
   when the inline style isn't present or is delayed.
*/

/* ===== FORCE MEDIA LAYER TO IGNORE JS HEIGHT SHRINK ===== */
/* ===== HARD OVERRIDE: LANDSCAPE TICKER SAFE AREA ===== */
.media-layer {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* let media respect ticker, not container height */
  padding-bottom: var(--ticker-bottom-reserve);
  box-sizing: border-box;
}

/* media fills padded area, never overlaps ticker */
.display-video,
.display-image {
  top: 0;
  left: 0;
  right: var(--ticker-reserve);
  bottom: 0;

  width: 100%;
  height: 100%;
  object-fit: fill;
}

.display-video {
  display: block;
}

.display-video.ready {
  display: block;
}

.display-video {
  opacity: 0;
  transition: opacity 120ms linear;
}

.display-video.ready {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/styles/displayTicker.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED,kCAAkC;AAClC;EACE,qBAAqB,UAAU,8CAA8C;EAC7E,4BAA4B,GAAG,2BAA2B;EAC1D,4BAA4B,GAAG,2CAA2C;EAC1E,6BAA6B,EAAE,6BAA6B;AAC9D;;AAEA,4EAA4E;AAC5E;EACE,6CAA6C;AAC/C;AACA;EACE,qDAAqD;AACvD;;AAEA;;;CAGC;;AAED,oCAAoC;AACpC;EACE,kBAAkB,IAAI,6BAA6B;EACnD,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,WAAW,sBAAsB;EAC5C,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,OAAO;EACP,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,4BAA4B,EAAE,qCAAqC;EACnE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;EAClB,SAAS;EACT,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU,EAAE,0BAA0B;EACtC,+BAA+B;EAC/B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,sFAAsF;AACtF;EACE,uCAAuC;AACzC;;AAEA,6CAA6C;AAC7C,6CAA6C,uBAAuB,EAAE;AACtE,+CAA+C,uBAAuB,EAAE;AACxE,6CAA6C,sBAAsB,EAAE;;AAErE,iFAAiF;AACjF,sDAAsD,uBAAuB,EAAE;AAC/E,wDAAwD,uBAAuB,EAAE;AACjF,sDAAsD,sBAAsB,EAAE;;AAE9E,0BAA0B;AAC1B,yCAAyC;AACzC;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,sCAAsC;AACtC;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,wEAAwE;AACxE;EACE,OAAO,8CAA8C,EAAE;EACvD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,OAAO,6CAA6C,EAAE;EACtD,OAAO,8CAA8C,EAAE;AACzD;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;EACX,sEAAsE;EACtE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU,EAAE,yBAAyB;EACrC,sBAAsB;AACxB;;AAEA;0FAC0F;AAC1F;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;GAC3B,mDAAmD;EACpD,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE,kCAAkC;EACpD,iBAAiB;EACjB,aAAa,EAAE,6CAA6C;EAC5D,UAAU;EACV,oBAAoB,EAAE,iBAAiB;EACvC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE,yCAAyC,wBAAwB,EAAE;;AAEnE,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EAEjB,2BAA2B;AAC7B;;AAEA,8EAA8E;AAC9E;EACE,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;CAQC;;AAED,6DAA6D;AAC7D,0DAA0D;AAC1D;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;;EAET,mDAAmD;EACnD,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;;EAEE,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,SAAS;;EAET,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* displayTicker.css\r\n   Final update: landscape ticker no longer overlaps media.\r\n   - Reserves right-side space when portrait ticker present (as before).\r\n   - Reserves bottom space when landscape ticker present so media area is shrunk (no JS changes).\r\n   - Uses CSS variables with :has() when available; includes comments for fallback.\r\n*/\r\n\r\n/* ===== CONFIG / FALLBACK ===== */\r\n:root {\r\n  --ticker-reserve: 0px;         /* horizontal reserve for portrait (default) */\r\n  --ticker-default-width: 60px;  /* default portrait width */\r\n  --ticker-bottom-reserve: 0px;  /* bottom reserve for landscape (default) */\r\n  --ticker-default-height: 60px; /* default landscape height */\r\n}\r\n\r\n/* If browser supports :has(), set reserves dynamically when tickers exist */\r\n:root:has(.display-ticker.portrait) {\r\n  --ticker-reserve: var(--ticker-default-width);\r\n}\r\n:root:has(.display-ticker.landscape) {\r\n  --ticker-bottom-reserve: var(--ticker-default-height);\r\n}\r\n\r\n/* OPTIONAL fallbacks for older WebViews (uncomment if :has() unsupported)\r\n   Uncomment to always reserve space:\r\n   :root { --ticker-reserve: 60px; --ticker-bottom-reserve: 60px; }\r\n*/\r\n\r\n/* ===== DISPLAY TICKER BASE ===== */\r\n.display-ticker {\r\n  position: absolute;   /* floats above the content */\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  z-index: 25;          /* above media layer */\r\n  color: inherit;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* text style */\r\n.display-ticker-text {\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n  transform: skewX(-12deg);\r\n  line-height: 1;\r\n  padding-top: 2px;\r\n  text-shadow: 0 0 6px currentColor;\r\n  display: inline-block;\r\n}\r\n\r\n/* track */\r\n.display-ticker-track {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n  will-change: transform;\r\n  animation-timing-function: linear;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n/* ticker item */\r\n.ticker-item {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* ===== LANDSCAPE (BOTTOM) ===== */\r\n.display-ticker.landscape {\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  /* use variable so CSS can update layout when ticker exists */\r\n  height: var(--ticker-bottom-reserve);\r\n  min-height: 0;\r\n  padding: 0 12px;\r\n  align-items: center;\r\n}\r\n\r\n/* spacing between messages in landscape */\r\n.display-ticker.landscape .ticker-item {\r\n  margin-right: 300px;\r\n}\r\n\r\n/* default horizontal animation (left) */\r\n.display-ticker.landscape .display-ticker-track {\r\n  animation-name: ticker-left;\r\n}\r\n\r\n/* landscape direction override (rightwards) */\r\n.display-ticker.landscape.right .display-ticker-track {\r\n  animation-name: ticker-right;\r\n}\r\n\r\n/* ===== PORTRAIT (RIGHT SIDE) ===== */\r\n.display-ticker.portrait {\r\n  top: 0;\r\n  right: 0;\r\n  height: 100%;\r\n  width: var(--ticker-reserve); /* controlled by :has() or fallback */\r\n  min-width: 48px;\r\n  display: block;\r\n  pointer-events: auto;\r\n}\r\n\r\n/* portrait track uses vertical column + transform-based animation (viewport-based) */\r\n.display-ticker.portrait .display-ticker-track {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(-120vh);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 240px; /* spacing between items */\r\n  animation-name: ticker-portrait;\r\n  animation-timing-function: linear;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n/* rotate text so it reads horizontally when rotated on the right side */\r\n.display-ticker.portrait .display-ticker-text {\r\n  white-space: nowrap;\r\n  transform: rotate(-90deg) skewX(-12deg);\r\n  transform-origin: center;\r\n}\r\n\r\n/* if portrait direction should be reversed, target .portrait.right on the component */\r\n.display-ticker.portrait.right .display-ticker-track {\r\n  animation-name: ticker-portrait-reverse;\r\n}\r\n\r\n/* ===== SPEEDS (horizontal defaults) ===== */\r\n.display-ticker.slow .display-ticker-track { animation-duration: 30s; }\r\n.display-ticker.medium .display-ticker-track { animation-duration: 15s; }\r\n.display-ticker.fast .display-ticker-track { animation-duration: 8s; }\r\n\r\n/* ===== PORTRAIT SPEED ADJUSTMENTS (to match perceived horizontal speed) ===== */\r\n.display-ticker.portrait.slow .display-ticker-track { animation-duration: 20s; }\r\n.display-ticker.portrait.medium .display-ticker-track { animation-duration: 10s; }\r\n.display-ticker.portrait.fast .display-ticker-track { animation-duration: 6s; }\r\n\r\n/* ===== KEYFRAMES ===== */\r\n/* horizontal left-to-right (landscape) */\r\n@keyframes ticker-left {\r\n  from { transform: translateX(100vw); }\r\n  to   { transform: translateX(-100%); }\r\n}\r\n\r\n/* horizontal rightwards (landscape) */\r\n@keyframes ticker-right {\r\n  from { transform: translateX(-100%); }\r\n  to   { transform: translateX(100vw); }\r\n}\r\n\r\n/* portrait: travel using viewport height to ensure full-screen travel */\r\n@keyframes ticker-portrait {\r\n  from { transform: translateX(-50%) translateY(-120vh); }\r\n  to   { transform: translateX(-50%) translateY(120vh); }\r\n}\r\n\r\n@keyframes ticker-portrait-reverse {\r\n  from { transform: translateX(-50%) translateY(120vh); }\r\n  to   { transform: translateX(-50%) translateY(-120vh); }\r\n}\r\n\r\n/* ===== MEDIA LAYER (ANDROID TV SAFE) ===== */\r\n.media-layer {\r\n  position: relative;\r\n  width: 100%;\r\n  /* reduce media height when landscape ticker exists (reserve bottom) */\r\n  background: black;\r\n  overflow: hidden;\r\n  z-index: 5; /* below ticker overlay */\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Video / Image are absolutely positioned and respect the right gutter\r\n   reserved for the portrait ticker via --ticker-reserve. Use contain to avoid cropping. */\r\n.display-video,\r\n.display-image {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: var(--ticker-reserve); \r\n   /* reserve space on the right for portrait ticker */\r\n  bottom: 0;\r\n  width: auto;\r\n  height: 100%;\r\n  object-fit: fill; /* ensure whole image is visible */\r\n  background: black;\r\n  display: none; /* JS toggles to 'block' when showing media */\r\n  z-index: 6;\r\n  pointer-events: none; /* signage-safe */\r\n  user-select: none;\r\n}\r\n\r\n/* ensure native video controls don't appear on some platforms */\r\n.display-video::-webkit-media-controls { display: none !important; }\r\n\r\n/* video appearance safety */\r\n.display-video {\r\n  outline: none;\r\n  -webkit-user-select: none;\r\n  user-select: none;\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* optional helper: allow a wrapper that fills the remaining width (if used) */\r\n.video-wrap {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: black;\r\n}\r\n\r\n.video-wrap video {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: fill;\r\n  max-width: none;\r\n  max-height: none;\r\n}\r\n\r\n/* ===== NOTES =====\r\n - This CSS uses :has() when available to detect presence of .display-ticker.landscape\r\n   and .display-ticker.portrait. If your WebView doesn't support :has(), enable the\r\n   fallback by uncommenting the fallback section above to always reserve the expected\r\n   ticker size.\r\n - The DisplayPage.jsx already sets inline height for media-layer when it knows the\r\n   ticker height; this CSS provides a safe fallback so landscape won't overlap even\r\n   when the inline style isn't present or is delayed.\r\n*/\r\n\r\n/* ===== FORCE MEDIA LAYER TO IGNORE JS HEIGHT SHRINK ===== */\r\n/* ===== HARD OVERRIDE: LANDSCAPE TICKER SAFE AREA ===== */\r\n.media-layer {\r\n  position: absolute !important;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n\r\n  /* let media respect ticker, not container height */\r\n  padding-bottom: var(--ticker-bottom-reserve);\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* media fills padded area, never overlaps ticker */\r\n.display-video,\r\n.display-image {\r\n  top: 0;\r\n  left: 0;\r\n  right: var(--ticker-reserve);\r\n  bottom: 0;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: fill;\r\n}\r\n\r\n.display-video {\r\n  display: block;\r\n}\r\n\r\n.display-video.ready {\r\n  display: block;\r\n}\r\n\r\n.display-video {\r\n  opacity: 0;\r\n  transition: opacity 120ms linear;\r\n}\r\n\r\n.display-video.ready {\r\n  opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
